import { LitElement, html } from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import {classMap,ClassInfo} from "lit/directives/class-map.js";
import { infoboxStyles } from './infobox.styles';
import './infobox.scss'
import '@/components/button/button'
import '@/components/link/link'
import '@/components/icon/icon'

/**
 * @slot default - Inhalt / Bodytext
 * @slot headline - Überschrift
 * @slot icon - Icon neben der Überschrift (Default der Variante wird überschrieben)
 * @slot links - Links in der Box, z.B. Downloads
 */
@customElement('sbk-infobox')
export class SbkInfobox extends LitElement {

    @property({attribute: 'primary-button-label'})
    primaryButtonLabel = ''

    @property({attribute: 'primary-button-href'})
    primaryButtonHref = ''

    @property({attribute: 'secondary-button-label'})
    secondaryButtonLabel = ''

    @property({attribute: 'secondary-button-href'})
    secondaryButtonHref = ''

    @property({attribute: 'bottom-link-label'})
    bottomLinkLabel = ''

    @property({attribute: 'bottom-link-href'})
    bottomLinkHref = ''

    @property()
    variant: 'info' | 'note' | 'success' | 'error' = 'info';

    /**
     * @internal
     */
    @state()
    private hasSlottedIcon = false;

    static get styles() {
        return infoboxStyles;
    }

    render() {
        return html`
            <div class="infobox-wrapper">
                <div class=${classMap(this.getClassMap())}>
                    <div class="headline-bodytext">
                        <div class="headline-icon">
                            <slot name="icon" @slotchange=${this.onIconSlotChange} ?hidden=${!this.hasSlottedIcon}></slot>
                            <sbk-icon symbol=${this.getIconForStatus()} class=${this.hasSlottedIcon ? ' hide' : ''}></sbk-icon>
                            <slot name="headline"></slot>
                        </div>
                        <div>
                            <slot></slot>
                        </div>
                        <div class="links">
                            <slot name="links"></slot>
                        </div>
                    </div>
                    ${this.renderControlButtons()}
                    ${this.renderBottomLink()}
                </div>
            </div>
        `;
    }

    renderControlButtons() {
        if (!this.primaryButtonLabel || !this.secondaryButtonLabel) {
            return ''
        }
        return html`
            <div class="control-buttons">
                ${this.renderPrimaryButton()}
                ${this.renderSecondaryButton()}
            </div>
        `;
    }

    renderPrimaryButton() {
        if (!this.primaryButtonHref || !this.primaryButtonLabel) {
            return ''
        }
        return html`<sbk-button href=${this.primaryButtonHref}>${this.primaryButtonLabel}</sbk-button>`;
    }

    renderSecondaryButton() {
        if (!this.secondaryButtonHref || !this.secondaryButtonLabel) {
            return ''
        }
        return html`<sbk-button variant="secondary" href=${this.secondaryButtonHref}>${this.secondaryButtonLabel}</sbk-button>`;
    }

    renderBottomLink() {
        if (!this.bottomLinkHref || !this.bottomLinkLabel) {
            return ''
        }
        return html`<sbk-link icon="chevron-left" href=${this.bottomLinkHref}>${this.bottomLinkLabel}</sbk-link>`;
    }

    onIconSlotChange() {
        this.hasSlottedIcon = !!this.renderRoot.querySelector('slot[name="icon"]');
    }

    getClassMap(): ClassInfo {
        return {
            'infobox': true,
            [`infobox--variant-${this.variant}`]: !!this.variant,
        };
    }

    private getIconForStatus(): string {
        return {
            'info': 'infobox-info',
            'note': 'infobox-exclamation',
            'error': 'infobox-error',
            'success': 'infobox-success'
        }[this.variant] || '';
    }
}
